import { render, staticRenderFns } from "./users_consents_list.vue?vue&type=template&id=db17e6aa&scoped=true&"
import script from "./users_consents_list.vue?vue&type=script&lang=js&"
export * from "./users_consents_list.vue?vue&type=script&lang=js&"
import style0 from "./users_consents_list.vue?vue&type=style&index=0&id=db17e6aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db17e6aa",
  null
  
)

export default component.exports